export default "__VITE_ASSET__DuLi0F3q__"